export default {
  nome: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  },
  tpEventoId: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  deslocamento: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  despesa: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  agendamento: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  visita: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  contato: {
    value: false,
    defaultValue: false,
    required: false,
    state: null
  },
  inative: {
    value: null,
    maxlength: '100',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/events/components/add/event-form.js